namespace GpScot.MobileClasses {
	export function init() {
		configureScreenWidth();
		window.onresize = configureScreenWidth;

		configureToggleableMenu('#toggle-menu', '#header-navigation', '#close-menu');
		configureToggleableMenu('#toggle-search', '#wrap-search', '#close-search');
	}

	enum ELEMENTS {
		Body = 'body',
	}

	enum CLASSES {
		Mobile = 'js-mobile-device',
		Desktop = 'js-desktop-device',
		OpeningHoursWidget = 'nhssf-opening-hours-widget',
		OpeningHoursWidgetHead = 'nhsuk-details__summary',
		OpeningHoursWidgetBody = 'nhsuk-details__text'
	}

	const openingTimesWidgetExpander = (isDesktopCheck) => {
		// If/when on desktop, enforce the component to open automatically.
		const expander = document.querySelector('.' + CLASSES.OpeningHoursWidget);
		if (!isDesktopCheck || !expander) {
			return;
		}
		const summaryHead = expander.querySelector(
			'.' + CLASSES.OpeningHoursWidgetHead
		);
		const summaryBody = expander.querySelector(
			'.' + CLASSES.OpeningHoursWidgetBody
		);
		expander.setAttribute('open', '');
		summaryHead.setAttribute('aria-expanded', 'true');
		summaryBody.setAttribute('aria-hidden', 'false');
		summaryBody.setAttribute('style', 'display: block;');
	};

	const configureScreenWidth = () => {
		const isDesktop = screen.width > 768;
		var body = document.querySelector(ELEMENTS.Body);
		body.classList.toggle(CLASSES.Mobile, !isDesktop);
		body.classList.toggle(CLASSES.Desktop, isDesktop);
		openingTimesWidgetExpander(isDesktop);
	};

	const configureToggleableMenu = (toggleId: string, toggleAreaId: string, closeButtonId: string) => {

		const ariaAttribute = 'aria-expanded';
		const toggleButton = document.querySelector<HTMLButtonElement>(toggleId);
		const toggledArea: HTMLElement|null = document.querySelector(toggleAreaId);

		const setState = (button: HTMLButtonElement | null, area: HTMLElement | null, toggle: boolean) => {
			button?.classList.toggle('is-active', toggle);
			button?.setAttribute(ariaAttribute, toggle.toString());

			area?.classList.toggle('js-show', toggle);
		};

		document
			.querySelector<HTMLButtonElement>(toggleId)
			?.addEventListener('click', () => {
				
				const toggle = toggleButton?.getAttribute(ariaAttribute) !== 'true';

				setState(toggleButton, toggledArea, toggle);
			});

		document
			.querySelector(closeButtonId)
			.addEventListener('click', (e: Event) => {
				e.preventDefault();

				setState(toggleButton, toggledArea, false);
			})
	}
}

